import { z } from "zod";

const PAGE_SIZE = 10;

// GET /sensors' own `search` matches sensor name, sensor type, company
// name, or device IMEI/code. Only one filter -- created date -- per the
// Sensor Assignment story (a sensorType filter was briefly added to the UI
// but removed -- searching by type text already covers that need). No
// per-column sort exists on this endpoint (only a direction, applied to
// createdAt).
export const sensorAssignmentsSearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
    sort: z.enum(["asc", "desc"]).optional(),
    // No `.trim()` here -- this value round-trips through the URL on every
    // keystroke (the search input is fully controlled by router state), so
    // trimming on parse would strip a trailing space the instant it's typed.
    search: z.string().min(1).optional(),
    createdFrom: z.string().datetime().optional(),
    createdTo: z.string().datetime().optional(),
  })
  .refine(
    (search) =>
      (search.createdFrom === undefined) === (search.createdTo === undefined),
  );

export type SensorAssignmentsSearch = z.infer<
  typeof sensorAssignmentsSearchSchema
>;
